import Report from "@/views/medical_record/report/medical_report.vue";
import Reports from "@/views/medical_record/report/index.vue";

export default [
  {
    path: "relatorios",
    name: "Relatorios",
    component: Reports,
    meta: { backTo: "/filas/medico" },
  },
  {
    path: "relatorio/:medicalReportId",
    name: "Editar relatorio",
    component: Report,
  },
  {
    path: "relatorio/novo",
    name: "Novo relatorio",
    component: Report,
  },
];
